import { BridgeComponent } from '@hotwired/hotwire-native-bridge';
import { typeIn } from '../../lib/reader';
import { playSound } from '../../lib/sounds';
import { say } from '../../lib/text';

export default class extends BridgeComponent {
  static component = 'nfcscanner';
  static values = {
    endpoint: String,
    mode: String, // 'scan' (default): POST to the endpoint · 'box': type into [data-reader=box]
    // The words, from the view: t('fire.scanner.nfc').to_json. Else fire-text.
    messages: Object,
  };

  say(key) {
    return this.messagesValue[key] || say(`scanner.nfc.${key}`);
  }

  scan() {
    console.log('NFC scan initiated from web');
    this.send('scan', {}, ({ data: nfcData }) => {
      console.log('NFC data received from native:', nfcData);
      if (nfcData && nfcData.success) {
        this.handleNfcData(nfcData);
      } else {
        this.send('scanCallback', { result: false });
        this.showError(nfcData?.error || this.say('none'));
      }
    });
  }

  async handleNfcData(nfcData) {
    try {
      if (this.modeValue !== 'box') {
        // For scan mode, submit directly without form - pass raw NFC data from iOS
        const response = await this.fetchData(this.endpointValue || '/scan', nfcData);
        const data = await response.json();

        this.send('scanCallback', { result: data.result && data.valid, message: data.message });
        this.updateUI(data);
      } else {
        // box mode: the page's own box and form take the read, the camera closes
        if (typeIn(this.extractCode(nfcData))) {
          this.send('scanCallback', { result: true });
          this.send('dismiss');
        } else {
          this.send('scanCallback', { result: false });
          this.showError(this.say('not_found'));
        }
      }
    } catch (error) {
      this.send('scanCallback', { result: false });
      this.showError(this.say('failed'));
    }
  }

  extractCode(nfcData) {
    // Extract code from NFC data - adjust based on your NFC data structure
    return nfcData.code || nfcData.id || JSON.stringify(nfcData);
  }

  async fetchData(endpoint, data) {
    return fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
      },
      body: JSON.stringify(data),
    });
  }

  updateUI(data) {
    // Clear existing messages
    this.hideMessages();

    console.log('Validity sound playing!', data.sound);
    playSound(data.sound);

    if (data.result && data.valid) {
      // Show success message
      this.showSuccess(data.message || this.say('valid'));

      // If there's tag data, could update some display
      if (data.tag) {
        console.log('Valid tag:', data.tag);
      }
    } else {
      // Show error message
      this.showError(data.message || data.error || this.say('invalid'));
    }
  }

  showSuccess(message) {
    const statusElement = document.getElementById('status-message');
    if (statusElement) {
      const span = statusElement.querySelector('span') || statusElement;
      span.textContent = message;
      statusElement.classList.remove('hidden');
      statusElement.className = 'alert alert-success mb-6';
    }

    // Auto-hide after 3 seconds
    setTimeout(() => this.hideMessages(), 3000);
  }

  showError(message) {
    const errorElement = document.getElementById('error-message') || document.getElementById('status-message');
    if (errorElement) {
      const span = errorElement.querySelector('span') || errorElement;
      span.textContent = message;
      errorElement.classList.remove('hidden');
      errorElement.className = 'alert alert-error mb-6';
    }

    // Auto-hide after 5 seconds
    setTimeout(() => this.hideMessages(), 5000);
  }

  hideMessages() {
    const statusElement = document.getElementById('status-message');
    const errorElement = document.getElementById('error-message');

    if (statusElement) {
      statusElement.classList.add('hidden');
    }

    if (errorElement) {
      errorElement.classList.add('hidden');
    }
  }
}
